/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Go_Next_UpInputs */

const en_cmd_go_next_up = /** @type {(inputs: Cmd_Go_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Next up`)
};

const de_cmd_go_next_up = /** @type {(inputs: Cmd_Go_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Als Nächstes`)
};

/**
* | output |
* | --- |
* | "Go to Next up" |
*
* @param {Cmd_Go_Next_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_go_next_up = /** @type {((inputs?: Cmd_Go_Next_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Go_Next_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_go_next_up(inputs)
	return en_cmd_go_next_up(inputs)
});